module.exports = __webpack_public_path__ + "static/audience-b428aa18859574642612a8ac9f4831a3.png";